import React from 'react'
import { checkAuthentication } from 'util/checkAuthentication'
import { userSignOut, userSignOutSuccess } from 'actions'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import AppMainContainer from './AppMainContainer'
import LoginContainer from './LoginContainer'
import IntlMessages from 'util/IntlMessages'
import queryString from 'query-string'
import debug from 'debug'

const authDebug = debug('linkgua:auth:checks')

const signOutPath = '/signout'

const SignOut = ({authUser, userSignOut, userSignOutSuccess, history, location}) => {
  const parsedSearch = queryString.parse(location.search)

  const returnTo = parsedSearch.returnTo ? parsedSearch.returnTo : signOutPath

  authDebug('signOut: %s, %o', returnTo, authUser)

  if (authUser) {
    if (checkAuthentication(authUser)) {
      authDebug('signOut: have currently valid token - signing it out')
      userSignOut(returnTo)
    } else {
      authDebug('signOut: token expired - clearing auth')
      // make sure we clear from storage tokens that are not valid anymore
      userSignOutSuccess(returnTo)
    }
    return null
  } else {
    authDebug('signOut: no authUser')
    if (returnTo !== signOutPath) {
      authDebug('signOut: non-default returnTo requested, redirecting there: %s', returnTo)
      history.push(returnTo)
    }
  }

  return (
    <AppMainContainer>
      <LoginContainer headerLabelId='signOut.header'>
        <div>
          <div className="mb-3">
            <h2><IntlMessages id='signOut.text'/></h2>
          </div>
          <div className="mb-3">
            <Button className="text-uppercase" onClick={() => history.push('/')}><IntlMessages id='signOut.loginBtnLabel'/></Button>
          </div>
        </div>
      </LoginContainer>
    </AppMainContainer>
  )
}

const mapStateToProps = ({auth}) => {
  const {authUser} = auth
  return {authUser}
}

const mapDispatchToProps = {userSignOut, userSignOutSuccess}

export default connect(mapStateToProps, mapDispatchToProps)(SignOut)



// WEBPACK FOOTER //
// ./Linkgua/containers/SignOut.js